import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits.
   * Minus is never disabled in cart — at minimum quantity it removes the item instead.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Keep minus always enabled so users can tap it to remove the item when qty=1
    minusButton.disabled = false;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Handles the quantity decrease event.
   * When already at minimum quantity, dispatches qty=0 to trigger line item removal.
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();

    const { value, min } = this.getCurrentValues();

    if (value <= min) {
      // At minimum — set to 0 so CartItemsComponent removes the line item
      this.refs.quantityInput.value = '0';
      this.onQuantityChange();
      this.updateButtonStates();
    } else {
      this.updateQuantity(-1);
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
